import { Component } from '@angular/core';
import {HeroSectionComponent} from "./hero-section/hero-section.component";
import {TeamHomeComponent} from "../team-home/team-home.component";
import {NavBarComponent} from "./nav-bar/nav-bar.component";
import {FooterComponent} from "../footer/footer.component";
import {FloatButtonComponent} from "../float-button/float-button.component";
import {FooterPersonaComponent} from "./footer-persona/footer-persona.component";
import {RouterOutlet} from "@angular/router";
import {TopBarComponent} from "../top-bar/top-bar.component";
import {ServicesHomeComponent} from "./services-home/services-home.component";
import {PromotionsFeaturedComponent} from "./promotions-featured/promotions-featured.component";
import {OurClientsComponent} from "./our-clients/our-clients.component";
import {SuscribeNewsletterComponent} from "./suscribe-newsletter/suscribe-newsletter.component";

@Component({
  selector: 'app-app-persona',
  standalone: true,
  imports: [
    HeroSectionComponent,
    TeamHomeComponent,
    NavBarComponent,
    FooterComponent,
    FloatButtonComponent,
    FooterPersonaComponent,
    RouterOutlet,
    TopBarComponent,
    ServicesHomeComponent,
    PromotionsFeaturedComponent,
    OurClientsComponent,
    SuscribeNewsletterComponent
  ],
  templateUrl: './app-persona.component.html',
  styleUrl: './app-persona.component.css'
})
export class AppPersonaComponent {

}
